const awsmobile = {
  aws_appsync_graphqlEndpoint: "https://api.fluentc.io/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-wtkl5bpofjbu5ex5iugu4o2mbm",
  aws_cognito_region: "us-east-1",
};
// const awsmobile = {
//   aws_appsync_graphqlEndpoint: "http://192.168.50.102:20002/graphql",
//   aws_appsync_region: "us-east-1",
//   aws_appsync_authenticationType: "API_KEY",
//   aws_appsync_apiKey: "da2-fakeApiId123456",
// };

export default awsmobile;
